/**
 * resource component to collect and organize agenda items by study 
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from '../../../global/components/BaseComponent.js.jsx';

import classNames from 'classnames';

import * as userModuleActions from '../../userModule/userModuleActions';

const simUrl = window.simUrl;
// not updating links here because this should no longer be used with london handling agenda

class AgendaTmListItem extends Base {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    const {
      agendaItem
      , contentModule
      , sponsor
      // we get the current UserModule from the AgendaItem here. this is generated by redstone server.
    } = this.props;
  
    const pending = agendaItem.certificateStatus == "pending-attestation";
    const expired = agendaItem.certificateStatus == "expired"; 
    const expiringSoon = agendaItem.certificateStatus == 'expiring-soon'; 
    const completed = agendaItem._certificate ? true : false;  
    const required = !agendaItem.optional;

    const userModule = agendaItem._userModule || {};

    // console.log("DEBUG", userModule)
    
    const tmClass = classNames(
      '-tm-list-item'
      , {
        '-pending tooltip': pending
        , '-expired tooltip': expired
        , '-expiring-soon tooltip': expiringSoon
        , '-completed': completed
      }
    )
  
    return (
      <div className={tmClass}>
        <div className="-icon">
          { pending ?
            <div className="-alert">
              <div className="-tip-text -top">
                VERIFICATION REQUIRED
              </div>
              <i className="far fa-exclamation-triangle"/>
            </div>
            : expired ?
            <div className="-alert">
              <div className="-tip-text -top">
                CERTIFICATE IS EXPIRED
              </div>
              <i className="far fa-exclamation-triangle"/>
            </div>
            : expiringSoon ? 
            <div className="-alert">
              <div className="-tip-text -top">
                CERTIFICATE IS EXPIRING SOON
              </div>
              <i className="far fa-exclamation-triangle"/>
            </div>
            : completed ? 
            <div className="">
              <i className="fas fa-check-circle"/>
            </div>
            : required ? 
            <div className="">
              <i className="fas fa-flag"/>
            </div>
            :
            null 
          }
        </div>
        <div className="-title">
          <div className="yt-row">
            {contentModule.title}
            {sponsor && sponsor.logo ? 
              <img className="-logo" src={sponsor.logo}/>
            : null
            }
          </div>
        </div>
        <div className="-actions">
          { pending ?
          // 0. REQUIRES ATTESTATION BEFORE COMPLETE
            <Link className="yt-btn pending" to={`/my-certificates/${agendaItem._certificate._id}`}>
              <i className="far fa-exclamation-triangle -btn-icon -left"/>
              Verification Required
            </Link>
          : agendaItem._certificate && !agendaItem.valid && agendaItem.userModuleTiedToLatestCert ?
            // 1. EXPIRED OR INVALID CERT, HAVEN'T RESTARTED - MUST RESTART
            // <button className="yt-btn danger " onClick={() => this.setState({confirmStartOver: true})}>
            <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
              <i className="far fa-exclamation-triangle -btn-icon -left"/>
              Restart Training
            </a>
          : agendaItem._certificate && !agendaItem.valid && !agendaItem._userModule ?
            // 2. EXPIRED OR INVALID CERT, HAVE NEVER STARTED - MUST RESTART
            // <button className="yt-btn danger " onClick={() => this.setState({confirmStartOver: true})}>
            <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
              <i className="far fa-exclamation-triangle -btn-icon -left"/>
              Restart Training
            </a>
          : agendaItem._certificate && !agendaItem.valid ?
            // 3. EXPIRED OR INVALID CERT, ALREADY RESTARTED THOUGH
            // TODO: UPDATE THIS FOR MIGRATIONS
            <a className="yt-btn danger" href={agendaItem._userModule && agendaItem._userModule._lastNode ? `${simUrl}/content-modules/${contentModule._id}/user-module/${userModule._id}/nodes/${userModule._lastNode}` : `${simUrl}/content-modules/${contentModule._id}/overview`}>
            {/* <Link className="yt-btn danger" to={agendaItem._userModule && agendaItem._userModule._lastNode ? `/my-agenda/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}` : `/my-agenda/cms/${contentModule.slug}`}> */}
              <i className="far fa-exclamation-triangle -btn-icon -left"/>
              Continue Training
            </a>
          : expiringSoon && agendaItem.userModuleTiedToLatestCert ?
            // 4. VALID CERT BUT EXPIRING SOON, MUST RESTART
            // <button className="yt-btn warning" onClick={() => this.setState({confirmStartOver: true})}>
            <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
              <i className="far fa-exclamation-triangle -btn-icon -left"/>
              Restart Training
            </a>                  
          : expiringSoon ?
            // 5. VALID CERT BUT EXPIRING SOON, ALREADY RESTARTED
            // TODO: UPDATE THIS FOR MIGRATIONS
            <a className="yt-btn warning" href={agendaItem._userModule && agendaItem._userModule._lastNode ? `${simUrl}/content-modules/${contentModule._id}/user-module/${userModule._id}/nodes/${userModule._lastNode}` : `${simUrl}/content-modules/${contentModule._id}/overview`}>
            {/* <Link className="yt-btn warning" to={agendaItem._userModule && agendaItem._userModule._lastNode ? `/my-agenda/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}` : `/my-agenda/cms/${contentModule.slug}`}> */}
              <i className="far fa-exclamation-triangle -btn-icon -left"/>
              Continue Training
            </a>
          : agendaItem._certificate ?
            // 6. VALID CERT
            <span>
              <a className="yt-btn muted" href={`${simUrl}/content-modules/${contentModule._id}/user-module/${userModule._id}/nodes/${contentModule._startNode}`}>
                Review
              </a>
              <Link className="yt-btn dark" to={`/my-agenda/cms/${contentModule.slug}/conclusion`}>
                Print Certificate
              </Link>
            </span>

          : agendaItem._userModule && agendaItem._userModule._lastNode ?
            // 7. NO CERTS BUT ALREADY STARTED MODULE

            // TODO: UPDATE THIS FOR MIGRATIONS
            <a className="yt-btn primary " href={`${simUrl}/content-modules/${contentModule._id}/user-module/${userModule._id}/nodes/${userModule._lastNode}`}>
            {/* <Link className="yt-btn primary " to={`/my-agenda/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}`}> */}
              Resume &rarr;
            </a>
          : agendaItem.locked ?
            // 8. NO CERTS AT ALL, AND ITS LOCKED
            // this is new in 2.10, locked is currently only for "ordered" courses, and its pretty limited.
            // we are assuming that it ONLY applies to the first time taking something, and not any expirations, restarts, etc
            <span style={{'background-color': 'white'}} className="yt-btn" href={`#`}>
              <i style={{'color':'gray'}} className="far fa-lock fa-solid -btn-icon"/>
            </span>
          :
            // 9. NO CERTS AT ALL, BEGIN
            <a className="yt-btn secondary brand-primary " href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
            {/* <Link className="yt-btn secondary brand-primary " to={`/my-agenda/cms/${contentModule.slug}`}> */}
              Begin
            </a>
          }
        </div>
        {/* <AlertModal
          alertMessage="Are you sure you want to restart your training?"
          alertTitle={"Confirm Restart Training"}
          closeAction={() => this.setState({confirmStartOver: false})}
          confirmAction={this._handleStartOver}
          confirmText={"Yes, continue"}
          declineAction={() => this.setState({confirmStartOver: false})}
          declineText={"Cancel"}
          isOpen={this.state.confirmStartOver}
          type="danger"
        /> */}
      </div>
    )
  }
}

AgendaTmListItem.propTypes = {
  agendaItem: PropTypes.object.isRequired 
  , certificates: PropTypes.array 
  , dispatch: PropTypes.func.isRequired
  , contentModule: PropTypes.object.isRequired 
  , userModules: PropTypes.array
}

AgendaTmListItem.defaultProps = {
  certificates: []
  , userModules: []
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {

  }
}


export default withRouter(connect(mapStoreToProps)(AgendaTmListItem));



// WEBPACK FOOTER //
// modules/agenda/components/AgendaTmListItem.js.jsx